import React from "react";
import { getStyle } from "./StylesHelper";

const ProductTagShape = ({
  tags = {},
  shapeOptions = [],
  styles = {},
  primaryColor,
  width = 70,
  height = 70,
}) => {
  const { id, color, label } = tags;

  const tagShapeObj = shapeOptions.find((s) => s.id === id);

  if (!tagShapeObj) return null;

  return (
    <div className="common_shape_tag">
      <div className="shape_tag_wrapper">
        {tagShapeObj.shapeType({
          color: color || primaryColor,
          width,
          height,
        })}
        <p className="tag_label" style={getStyle(styles, "tags")}>
          {label}
        </p>
      </div>
    </div>
  );
};

export default ProductTagShape;
